export const OLINGO_BARS = Array.from({ length: 52 }, (_, i) => {
  const v = 0.22 + 0.78 * Math.abs(Math.sin(i * 0.7) * 0.6 + Math.sin(i * 0.31 + 1) * 0.4);
  return Math.max(0.16, Math.min(1, v)).toFixed(3);
});

export function Sk({ w, h = '7px', t = false }: { w: string; h?: string; t?: boolean }) {
  return <span className={`csmk-sk${t ? ' t' : ''}`} style={{ width: w, height: h }} />;
}
